'use client';

import { Dialog, DialogContent } from '#/components/ui/dialog';
import { EthereumStakingValidatorInfo } from '#/data/react-query/queries/order-list';
import { cn } from '#/lib/utils';
import { DialogContentProps, DialogProps } from '@radix-ui/react-dialog';
import { useActor, useInterpret } from '@xstate/react';
import React, { useMemo } from 'react';
import { Confirmation } from './components/confirmation';
import { SourceValidators } from './components/source-validators';
import machine, { MachineContext } from './contexts/machine';

interface Props {
  originalRow: EthereumStakingValidatorInfo;
}
function DialogContentImpl({ originalRow }: Props) {
  const interpreter = useInterpret(machine, {
    context: { target: originalRow },
  });
  const [state, dispatch] = useActor(interpreter);

  const stepComponents = useMemo(
    () => ({
      'source-validators': SourceValidators,
      confirmation: Confirmation,
    }),
    []
  );

  const StepComponent = useMemo(() => {
    for (const [key, component] of Object.entries(stepComponents)) {
      if (state.matches(key)) {
        return component;
      }
    }
    return React.Fragment;
  }, [state, stepComponents]);

  return (
    <MachineContext.Provider value={interpreter}>
      <StepComponent />
    </MachineContext.Provider>
  );
}

export function ConsolidateValidatorDialogContent({
  originalRow,
  className,
  ...props
}: Props & DialogContentProps) {
  return (
    <DialogContent
      {...props}
      className={cn(
        'sm:max-w-(--breakpoint-sm) overflow-auto max-h-screen',
        className
      )}
    >
      <DialogContentImpl originalRow={originalRow} />
    </DialogContent>
  );
}

export function ConsolidateValidatorDialog({
  originalRow,
  ...props
}: Props & DialogProps) {
  return (
    <Dialog {...props}>
      <ConsolidateValidatorDialogContent originalRow={originalRow} />
    </Dialog>
  );
}
